export const getObjectDimensions = (width, height, isInCm = false) => {
    if (!width || !height)
        return '-';
    return isInCm
        ? `${width / 10} x ${height / 10} cm`
        : `${width} x ${height} mm`;
};
